import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/status-out-of-hours.svg'
import _imports_1 from '@/assets/icons/status-standard-icon.svg'
import _imports_2 from '@/assets/icons/status-emergency.svg'
import _imports_3 from '../../../assets/icons/bell-icon.svg'
import _imports_4 from '../../../assets/images/empty-issue.png'


const _withScopeId = n => (_pushScopeId("data-v-5781dd7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "issue_loader"
}
const _hoisted_2 = {
  key: 1,
  class: "active_issues"
}
const _hoisted_3 = { class: "active_issues__heading" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Issues", -1))
const _hoisted_5 = { class: "active_issues__selector" }
const _hoisted_6 = { class: "custom__cards" }
const _hoisted_7 = {
  key: 0,
  class: "custom__card__list"
}
const _hoisted_8 = { class: "custom__card__header" }
const _hoisted_9 = { class: "custom__card__header__left" }
const _hoisted_10 = {
  key: 0,
  class: "emergency-out-of-hours"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Out Of Hours"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Out Of Hours", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "standard"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Standard"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Standard", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "emergency"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Emergency"
  })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Emergency", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "custom__card__header__right" }
const _hoisted_23 = { class: "custom__card__content" }
const _hoisted_24 = { class: "custom__card__content__header" }
const _hoisted_25 = { class: "custom__card__content__title" }
const _hoisted_26 = {
  key: 0,
  class: "custom__card__content__time"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_28 = { class: "time_text" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "custom__card__content__description" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "custom__card__footer" }
const _hoisted_35 = { class: "custom__card__footer__left" }
const _hoisted_36 = { class: "card__date" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "bright-blue-text" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"empty__content\" data-v-5781dd7e><div class=\"empty__banner\" data-v-5781dd7e><div class=\"empty__banner__img\" data-v-5781dd7e><img src=\"" + _imports_4 + "\" alt=\"\" data-v-5781dd7e></div><div class=\"empty__banner__content text-center\" data-v-5781dd7e><h4 data-v-5781dd7e>You haven’t raised any issues yet.</h4><p data-v-5781dd7e>Raise your next issue at lightning speed.</p></div></div></div>", 1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_IssueReviewComponent = _resolveComponent("IssueReviewComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.createdIssueId && !$setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_select, {
                class: "custom-select filter input_field",
                density: "compact",
                variant: "outlined",
                clearable: "",
                placeholder: "Issue Type",
                modelValue: $setup.filters.selectedType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.selectedType) = $event)),
                items: $setup.issueType,
                "item-title": "text",
                "item-value": "value",
                "menu-props": {
            contentClass: 'icon__text__select icon__text__select_smaller',
          }
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_select, {
                class: "custom-select status input_field",
                density: "compact",
                variant: "outlined",
                clearable: "",
                placeholder: "Issue Status",
                modelValue: $setup.filters.selectedStatus,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.selectedStatus) = $event)),
                items: $setup.issueStatus,
                "item-title": "text",
                "item-value": "value",
                "menu-props": {
            contentClass: 'icon__text__select icon__text__select_smaller',
          }
              }, null, 8, ["modelValue", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            ($setup.allIssue?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allIssue, (issue) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      class: "custom__card",
                      key: issue.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (issue.issueType === 'emergency_out_of_hours')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                              : _createCommentVNode("", true),
                            (issue.issueType === 'standard')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                              : _createCommentVNode("", true),
                            (issue.issueType === 'emergency')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  completed: issue.issueStatus === 'completed',
                  draft: issue.issueStatus === 'draft',
                  raised: issue.issueStatus === 'raised',
                  inprogress: issue.issueStatus === 'inprogress',
                })
                            }, [
                              _createVNode(_component_v_icon, { icon: " mdi-checkbox-marked-circle" }),
                              _createElementVNode("p", null, _toDisplayString($setup.getIssueStatus(issue.issueStatus)), 1)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("h5", null, _toDisplayString(issue.name), 1),
                              _createElementVNode("span", null, "Issue ID: #" + _toDisplayString(issue?.refId), 1)
                            ]),
                            (issue.SLATime)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _hoisted_27,
                                  _createElementVNode("div", _hoisted_28, [
                                    (issue.slaTime?.hours && issue.slaTime?.minutes)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                          _createElementVNode("span", null, _toDisplayString(issue.slaTime?.hours) + " Hours " + _toDisplayString(issue.slaTime?.minutes), 1),
                                          _createTextVNode("Mins Left ")
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!issue.slaTime?.hours && issue.slaTime?.minutes)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                                          _createElementVNode("span", null, _toDisplayString(issue.slaTime?.minutes), 1),
                                          _createTextVNode("Mins Left ")
                                        ]))
                                      : _createCommentVNode("", true),
                                    (issue.slaTime?.hours && !issue.slaTime?.minutes)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                          _createElementVNode("span", null, _toDisplayString(issue.slaTime?.hours), 1),
                                          _createTextVNode("Hours Left ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("p", {
                              innerHTML: issue.description
                            }, null, 8, _hoisted_33)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.getCreatedDate(issue.dateCreated)), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "custom__card__footer__right",
                            onClick: ($event: any) => ($setup.onClickDetails(issue?.id))
                          }, [
                            _createElementVNode("label", _hoisted_38, [
                              _createTextVNode(" Details"),
                              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                            ])
                          ], 8, _hoisted_37)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.createdIssueId)
      ? (_openBlock(), _createBlock(_component_IssueReviewComponent, {
          key: 2,
          isShowDeleteButton: true,
          createdIssueId: $setup.createdIssueId,
          onOnClickBackButton: $setup.onClickBackButtonFromReview,
          onGoToListIssuesTab: $setup.goToListIssuesTab
        }, null, 8, ["createdIssueId", "onOnClickBackButton", "onGoToListIssuesTab"]))
      : _createCommentVNode("", true)
  ], 64))
}